import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appsPipe'
})
export class AppsPipePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return this.getStatus(value);
  }

  getStatus(status: string): String {
    if (status === 'issue_contract') {
      return 'Contract issued';
    } else if (status === 'pending') {
      return 'Pending';
    } else if (status === 'rejected') {
      return 'Rejected';
    } else if (status === 'progress') {
      return 'Progress';
    } else if (status === 'approved') {
      return 'Aproved';
    }
    return '--'
  }

}
